import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import NotFound from '@/views/NotFound.vue'
import StatisticsDashboard from '@/components/content_containers/StatisticsDashboard.vue'
import ManageDevices from '@/components/content_containers/ManageDevices.vue'
import ManageForms from '@/components/content_containers/ManageForms.vue'
import DesignForm from '@/components/content_containers/DesignForm.vue'
import ControlPanel from '@/components/content_containers/ControlPanel.vue'

const routes: Array<RouteRecordRaw> = [
  {
    name: 'Dashboard',
    path: '/',
    component: StatisticsDashboard,
    meta: { requiresAuth: true }
  },
  {
    name: 'Devices',
    path: '/devices',
    component: ManageDevices,
    meta: { requiresAuth: true }
  },
  {
    name: 'Forms',
    path: '/forms',
    component: ManageForms,
    meta: { requiresAuth: true }
  },
  {
    name: 'CreateForm',
    path: '/forms/create',
    component: DesignForm,
    meta: { requiresAuth: true }
  },
  {
    name: 'EditForm',
    path: '/forms/edit/:formIdProp?',
    component: DesignForm,
    props: true
  },
  {
    name: 'ControlPanel',
    path: '/control-panel',
    component: ControlPanel,
    meta: { requiresAuth: true }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  next()
})

export default router
